import { render, staticRenderFns } from "./CategoryGoodsTemplate.vue?vue&type=template&id=029f10c8"
import script from "./CategoryGoodsTemplate.vue?vue&type=script&lang=js"
export * from "./CategoryGoodsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports